<template>
  <div>
    <div v-if="todayAbsence.length">
      <div>
        <div v-if="loading">
          <v-progress-linear
            class="mx-2"
            color="primary"
            indeterminate
          ></v-progress-linear>
        </div>
        <div v-if="attendance">
          <div class="mb-2">
            <v-breadcrumbs class="px-0" :items="breadcrumbsItems"></v-breadcrumbs>
          </div>
          <div class="mb-6">
            <h2>
              欠席確認・削除<br /><br />{{ attendance.child.lastName
              }}{{ attendance.child.firstName }}
            </h2>
               <br /><br />
              日付 ： {{ attendance.date }}
          </div>
          <div class="mb-4">
            <div>理由</div>
            <template v-if="todayAbsence[0] && todayAbsence[0].absenceDetails">
              <v-card-text style="white-space:pre-wrap;">
                {{ showReason(todayAbsence[0].absenceDetails.reason) }}
              </v-card-text>
              <template v-if="todayAbsence[0].absenceDetails.comment">
                <v-card-subtitle> コメント </v-card-subtitle>
                <v-card-text style="white-space:pre-wrap;">
                  {{ todayAbsence[0].absenceDetails.comment }}
                </v-card-text>
              </template>
            </template>
          </div>
          <v-row justify="center" class="pt-10">
            <v-btn
              @click="deleteAbsence"
              :disabled="isSaving"
              color="error"
              variant="outlined"
              x-large
              >削除</v-btn
            >
          </v-row>
          <div>
            <v-progress-linear
              v-if="isSaving"
              indeterminate
              color="primary"
              class="my-8"
            ></v-progress-linear>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        <!-- お休み登録 -->
        <v-dialog max-width="640px" v-model="isAbsenceRegisterDialogOpen">
          <v-card>
            <v-toolbar dark color="primary" tile flat class="mb-5">
              <v-toolbar-title>{{ attendance.child.lastName}}{{ attendance.child.firstName }}の欠席登録</v-toolbar-title>
            </v-toolbar>
            <div>
              <h2>
                <center>
                  {{ attendance.date }}
                </center>
              </h2>
            </div>
            <v-card-text class="py-3">
              <v-select
                v-model="reason"
                :rules="[rules.required]"
                label="理由"
                :items="choices"
                item-title="text"
                item-value="value"
                variant="outlined"
                density="compact"
                color="primary"
              />
              <v-select
                v-model="infectionReason"
                :rules="[infectionRules]"
                v-if="reason === 'infection'"
                label="詳細"
                :items="infectionChoices"
                item-title="text"
                item-value="value"
                variant="outlined"
                density="compact"
                color="primary"
              />
              <v-textarea
                v-model="comment"
                v-if="reason === 'others'"
                :rules="[rules.counter500]"
                label="コメント"
                auto-grow
                variant="outlined"
                density="compact"
                color="primary"
              />
            </v-card-text>

            <v-card-actions class="justify-center">
              <v-btn
                :disabled="isSaving"
                variant="flat"
                color="primary"
                class="mx-2"
                @click="clickAbsencePost"
              >
                保存
              </v-btn>
            </v-card-actions>
            <v-progress-linear
              v-if="isUpdatingStaffs"
              indeterminate
              color="primary"
            ></v-progress-linear>
          </v-card>
        </v-dialog>
        <div v-if="loading">
          <v-progress-linear
            class="mx-2"
            color="primary"
            indeterminate
          ></v-progress-linear>
        </div>
        <div v-if="attendance">
          <div class="mb-2">
            <v-breadcrumbs class="px-0" :items="breadcrumbsItems"></v-breadcrumbs>
          </div>
          <div class="mb-6">
            <h2>
              {{ attendance.date }} : {{ attendance.child.lastName
              }}{{ attendance.child.firstName }}
            </h2>
          </div>
          <div class="mb-4">
            <div>登園時間</div>
            <v-text-field variant="outlined" type="time" v-model="attendedAt" color="primary"></v-text-field>
          </div>
          <div class="mb-4">
            <div>降園時間</div>
            <v-text-field variant="outlined" type="time" v-model="leftAt" color="primary"></v-text-field>
          </div>
          <v-row justify="center">
            <v-btn
              color="primary"
              variant="flat"
              x-large
              :disabled="isSaving"
              @click="save"
              >保存</v-btn
            >
          </v-row>
          <v-row justify="center" class="pt-10">
            <v-btn
              @click="deleteAttendance"
              :disabled="isSaving || attendance.attendanceId == -1"
              color="error"
              variant="outlined"
              x-large
              >登園・降園削除</v-btn
            >
          </v-row>
          <v-row justify="center" class="pt-10">
            <v-btn
              @click="openModalAbsence"
              :disabled="isSaving || attendedAt !== null"
              color="primary"
              variant="outlined"
              x-large
              >欠席登録</v-btn
            >
          </v-row>
          <div>
            <v-progress-linear
              v-if="isSaving"
              indeterminate
              color="primary"
              class="my-8"
            ></v-progress-linear>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { attendanceEditModule } from "@/store/dataModules/attendanceEditModule";
import dayjs from "dayjs";
import ApiAttendance from "@/api/ApiAttendance";
import LocalDataService from "@/service/LocalDataService";
import { chatModule } from '@/store/dataModules/chatModule';
import { AbsenceReason, AbsenceReasonType, NurseryAttendanceResponse } from 'chaild-api/lib';

interface DataType {
  isAbsenceRegisterDialogOpen: boolean;
  isSaving: boolean;
  loading: boolean;
  reason: string;
  infectionReason: string;
  comment: string | null;
  rules: {
    required: (value: any) => boolean | string;
    counter500: (value: any) => boolean | string;
  };
  infectionRules: (value: any) => boolean | string;
  choices: { text: string; value: string }[];
  infectionChoices: { text: string; value: string }[];
  isUpdatingStaffs: boolean;
}

export default defineComponent({
  computed: {
    attendance() {
      return attendanceEditModule.attendance;
    },
    todayAbsence() {
      const attendanceDate = attendanceEditModule.attendance ? attendanceEditModule.attendance.date : null;
      if (!attendanceDate) {
        return [];
      }
      return chatModule.chatsAbsence.filter(ca => ca.date == attendanceDate);
    },
    attendedAt: {
      get(): string | null {
        if (
          attendanceEditModule.attendance &&
          attendanceEditModule.attendance.attendedAt
        ) {
          return dayjs(attendanceEditModule.attendance.attendedAt).format(
            "HH:mm"
          );
        }
        return null;
      },
      set(value: string) {
        if (this.date && value) {
          const date = dayjs(this.date + value).toISOString();
          attendanceEditModule.setAttendedAtValue(date);
        }
      },
    },
    leftAt: {
      get(): string | null {
        if (
          attendanceEditModule.attendance &&
          attendanceEditModule.attendance.leftAt
        ) {
          return dayjs(attendanceEditModule.attendance.leftAt).format("HH:mm");
        }
        return null;
      },
      set(value: string) {
        if (this.date && value) {
          const date = dayjs(this.date + value).toISOString();
          attendanceEditModule.setLeftAtValue(date);
        }
      },
    },
    date() {
      return this.$route.params.date;
    },
    breadcrumbsItems: function () {
      //日付をlocalStorageに保存
      const routeDate = this.$route.params.date;
      localStorage.setItem('date', routeDate as string);
      return [
        { title: "出欠管理", href: "/attendance/list", color: "primary" },
        { title: "登園・降園編集", href: "", disabled: true },
      ];
    },
  },

  data: (): DataType => {
    return {
      reason: '',
      infectionReason: '',
      comment: '',
      isAbsenceRegisterDialogOpen: false,
      isSaving: false,
      loading: false,
      rules: {
        required: (value) => !!value || '必須項目です。',
        counter500: (value) => (value || '').length <= 500 || '500文字以内で入力してください。',
      },
      infectionRules: (value) => !!value || '必須項目です。',
      choices: [
        { text: '家庭の事情', value: 'personal' },
        { text: '発熱', value: 'fever' },
        { text: '感染症', value: 'infection' },
        { text: 'その他', value: 'others' },
      ],
      infectionChoices: [
        { text: '溶連菌感染症', value: 'infStrep' },
        { text: 'マイコプラズマ肺炎', value: 'infMycoplasma' },
        { text: '手足口病', value: 'infHFMD' },
        { text: '伝染性紅斑（りんご病）', value: 'infSlappedCheek' },
        { text: 'ウイルス性胃腸炎（ノロ、ロタ、アデノ等）', value: 'infStomach' },
        { text: 'ヘルパンギーナ', value: 'infHerpangina' },
        { text: 'RSウィルス感染症', value: 'infRS' },
        { text: '帯状疱疹', value: 'infZoster' },
        { text: '突発性発しん', value: 'infRoseola' },
        { text: '伝染性膿痂疹（とびひ）', value: 'infImpetigo' },
        { text: '新型コロナウイルス', value: 'covid19' },
        { text: 'インフルエンザA型', value: 'infInfluenzaA' },
        { text: 'インフルエンザB型', value: 'infInfluenzaB' },
      ],
      isUpdatingStaffs: false,
    };
  },

  methods: {
    async clickAbsencePost() {
      this.isSaving = true;
      const startedAt = this.attendance?.date;
      const endedAt = this.attendance?.date;
      if (!this.comment) {
        this.comment = null;
      }
      if (!startedAt || !endedAt) {
        return false;
      }
      try {
        if (this.reason === 'infection') {
          if (!this.infectionReason) {
            alert('詳細を選んでください');
            this.isSaving = false;
            return false;
          }
          await chatModule.postChatsAbsence({
            childId: Number(this.$route.params.childId),
            startedAt: startedAt,
            endedAt: endedAt,
            reason: this.infectionReason,
          });
        } else {
          if (!this.reason) {
            alert('理由を選んでください');
            this.isSaving = false;
            return false;
          }
          if (this.reason === 'others') {
            if (!this.comment) {
              alert('コメントを入力してください');
              this.isSaving = false;
              return false;
            }
            if (this.comment?.length >= 500) {
              alert('コメントを500文字以内で入力してください。');
              this.isSaving = false;
              return false;
            }
          }
          await chatModule.postChatsAbsence({
            childId: Number(this.$route.params.childId),
            startedAt: startedAt,
            endedAt: endedAt,
            reason: this.reason,
            comment: this.comment,
          });
        }
        this.$emit('posted');
        this.$emit('close');
        this.isSaving = false;
        this.$router.push({ path: "/attendance/list" });
      } catch (error) {
        this.$emit('close');
        this.isSaving = false;
        this.$router.push({ path: "/attendance/list" });
      }
    },
    showReason(reason: AbsenceReasonType): string {
      switch (reason) {
        case AbsenceReason.fever:
          return '発熱';
        case AbsenceReason.personal:
          return '家庭の事情';
        case AbsenceReason.infStrep:
          return '溶連菌感染症';
        case AbsenceReason.infMycoplasma:
          return 'マイコプラズマ肺炎';
        case AbsenceReason.infHFMD:
          return '手足口病';
        case AbsenceReason.infSlappedCheek:
          return '伝染性紅斑（りんご病）';
        case AbsenceReason.infStomach:
          return 'ウイルス性胃腸炎（ノロ、ロタ、アデノ等）';
        case AbsenceReason.infHerpangina:
          return 'ヘルパンギーナ';
        case AbsenceReason.infRS:
          return 'RSウィルス感染症';
        case AbsenceReason.infZoster:
          return '帯状疱疹';
        case AbsenceReason.infRoseola:
          return '突発性発しん';
        case AbsenceReason.infImpetigo:
          return '伝染性膿痂疹（とびひ）';
        case AbsenceReason.covid19:
          return '新型コロナウイルス';
        case AbsenceReason.infInfluenzaA:
          return 'インフルエンザA型';
        case AbsenceReason.infInfluenzaB:
          return 'インフルエンザB型';
        case AbsenceReason.others:
          return 'その他';
        default:
          return '';
      }
    },
    async getAttendance() {
      this.loading = true;
      await attendanceEditModule.getAttendance();
      this.loading = false;
    },
    async save() {
      this.isSaving = true;
      if (attendanceEditModule.attendance) {
        if (attendanceEditModule.attendance.attendanceId == -1) {
          // create
          await attendanceEditModule.createAttendance();
        } else {
          // update
          await attendanceEditModule.updateAttendance().catch(() => {
            alert(
              "保存できませんでした。売上情報を確定している場合などは、編集できません。"
            );
          });
        }
      }
      this.isSaving = false;
    },
    async deleteAbsence() {
      this.isSaving = true;
      const answer = confirm("欠席記録を削除しますか？");
      this.isSaving = true;
      if (answer) {
        const nurseryId = LocalDataService.getNurseryId();
        if (this.attendance) {
          await chatModule.deleteChatsAbsence({
            childId: Number(this.$route.params.childId),
            date: this.attendance.date,
          });
          this.$emit('posted');
          alert("削除しました");
        } else {
          console.error('Attendance object is null.');
        }
        this.$emit('posted');
        this.$router.push({ path: "/attendance/list" });
      }
      this.isSaving = false;
    },
    async deleteAttendance() {
      const answer = confirm("登園・降園記録を削除しますか？");
      this.isSaving = true;
      if (answer) {
        const nurseryId = LocalDataService.getNurseryId();
        if (
          this.attendance?.attendanceId &&
          this.attendance.child.childId &&
          nurseryId
        ) {
          const response = await ApiAttendance.deleteAttendance({
            attendanceId: this.attendance.attendanceId,
            childId: this.attendance.child.childId,
            nurseryId,
          }).catch((e) => console.warn(e));
          if (response) {
            alert("削除しました");
            this.$router.push({ path: "/attendance/list" });
          }
        }
      }
      this.isSaving = false;
    },
    async openModalAbsence() {
      this.isAbsenceRegisterDialogOpen = true;
    },
  },

  async mounted() {
    this.loading = true;
    const date = this.$route.params.date;
    const childId = this.$route.params.childId;
    await chatModule.getChatsAbsence(Number(childId));

    if (date && childId) {
      try {
        const parsed = parseInt(childId as string, 10);
        attendanceEditModule.setChildId(parsed);
        attendanceEditModule.setDate(date as string);

        this.getAttendance();
      } catch {
        return;
      }
    }
  },
});
</script>
